export class OpenidProviderComponent {

  constructor() {
  }

  public getErrorMsg(err): string {
    if (!err) {
      return;
    }
    const {error} = err;
    return error;
  }

  public encodeCustomParams(customParams: object): string {
    let state = window.btoa(JSON.stringify(customParams));
    state = encodeURIComponent(state);
    return state;
  }

}
